<template>
  <el-dialog
    :visible.sync="visibleInner"
    :top="'0px'"
    :width="dialogWidth"
    :close-on-click-modal="closeOnClickModal"
    :before-close="close"
    class="dialog-box"
    v-bind="$attrs"
  >
    <div class="dialog-content" :style="{ height: dialogHeight, ...dialogContentStyle}">
      <div class="dialog-title" v-if="title">
        <div>
          <span v-if="typeof title === 'string'">{{ title }}</span>
          <component v-else :is="title" />
        </div>
        <i class="iconhuice icon-guanbi" @click="close" />
      </div>
      <!-- <component :is="_component" ref="component" v-loading="loading" class="dialog-wrap" /> -->
      <component v-if="component" :is="_component" ref="component" v-loading="loading" class="dialog-wrap" />
      <div v-else name="default" v-loading="loading" class="dialog-wrap">
        <slot name="default" ></slot>
      </div>
    </div>
<!--
    <div style="flex:1;overflow-y:auto;padding:16px" :style="{height:height}" >
      <component :is="_component" ref="component" v-loading="loading" class="dialog-wrap" />
    </div> -->
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogWrap',
  props: {
    title: {
      type: [String, Object]
    },
    width: {
      type: String,
      default: 'small'
    },
    component: {
      type: Function,
      required: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    isMaxHeight: { // 最大高度,建议用这个属性，弹窗会尽可能的铺满屏幕
      type: Boolean,
      default: false
    },
    height: { // 正常高度
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false,
    },
    // height: {
    //   type: String,
    //   default: ''
    // },
    dialogContentStyle: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  emits: ['update:visible'],
  data() {
    return {
      // visible: false,
      loading: false,
    }
  },
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    dialogWidth() {
      switch (this.width) {
        case 'mini': return '467px'
        case 'small': return '560px'
        case 'middle': return '720px'
        case 'middle2': return '960px'
        case 'big': return '1200px'
        default: return this.width
      }
    },
    dialogHeight() {
      // 设置固定高度
      if (this.height) {
        return this.height
      }

      // 设置尽可能高的高度，铺满整个屏幕
      if (this.isMaxHeight) {
        return 'calc(100vh - 72px)'
      }

      // 默认不管，有多高撑多高
      return ''
    },
    _component() {
      const fn = this.component
      let vNode
      const that = this

      return {
        name: 'dynamic-comp',
        render() {
        // render中调用才会响应式处理
          vNode = fn()

          let listeners
          listeners = (vNode.componentOptions).listeners
          if (!listeners) {
            listeners = {};
            (vNode.componentOptions).listeners = listeners
          }

          // 添加done
          const orginDoneHandler = listeners.done

          listeners.done = (...p) => {
            if (orginDoneHandler) orginDoneHandler(...p)
            that.handleComponentDone(...p)
          }
          // // 添加cancel
          const orginCancelHandler = listeners.cancel

          listeners.cancel = function(...p) {
            if (orginCancelHandler) orginCancelHandler(...p)
            that.close()
          }

          listeners.loading = that.setLoading

          return vNode
        }
      }
    }

  },
  methods: {
  // 组件处理完自己的事情触发，默认关闭弹窗
    handleComponentDone() {
      this.$emit('done', arguments)

      this.close()
    },

    close() {
      // 从handleComponentDone处调用的close没有done参数

      this.visibleInner = false
      this.loading = false

      this.$refs.component && this.$refs.component.$destroy()
    },

    setLoading(bool) {
      this.loading = bool
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-box{
  display: flex;
  justify-content: center;
  align-items: center;
  .dialog-content{
    max-height: calc(100vh - 72px);
    min-height: 200px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    ::v-deep .dialog-title{
      display: flex;
      padding: 16px;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: $G9;
      border-bottom: 1px solid #DCDEE0;
      font-weight: 600;
      .icon-guanbi{
        font-weight: 400;
      }
    }
    .dialog-wrap{
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      ::v-deep .dialog-body{
        padding: 16px;
        flex: 1;
        overflow: auto;
      }
      ::v-deep .dialog-footer{
        padding: 16px;
        border-top: 1px solid #DCDEE0;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
.el-dialog__wrapper {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  ::v-deep .el-dialog__header {
    display: none;
  }
  // ::v-deep .el-dialog__footer {
  //   padding: 0;
  // }

  // ::v-deep .body {
  //   // flex: 1 1 auto;
  //   overflow-x: hidden;
  // }
  // ::v-deep .footer {
  //   // flex: 0 0 auto;
  //   padding: 10px 0 0;
  //   text-align: right;
  //   box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  // }
}
</style>
